import { memo } from 'react'

import { Autoplay } from 'swiper/modules'

import { Carousel } from 'components/carousel'
import useWindowSize from 'hooks/useWindowSize'

import { columns } from './data'
import * as S from './styles'

export const TrustBar = memo(() => {
  const { isMobile } = useWindowSize()

  if (isMobile) {
    return (
      <S.MobileCarousel>
        <Carousel
          swiperOptions={{
            modules: [Autoplay],
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 12,
            autoplay: { delay: 0, disableOnInteraction: false },
            speed: 4000,
            allowTouchMove: false,
            a11y: { enabled: false }
          }}
        >
          {columns.map(({ key, content }) => (
            <S.Item key={key}>{content}</S.Item>
          ))}
        </Carousel>
      </S.MobileCarousel>
    )
  }

  return (
    <S.TrustBar>
      {columns.map(({ key, content }) => (
        <S.Item key={key}>{content}</S.Item>
      ))}
    </S.TrustBar>
  )
})

TrustBar.displayName = 'TrustBar'
